import React, { useState } from 'react';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Cells from '../ListCells/Cells/Cells';
import { PageSubTitle, ListContactName } from '../Elements';
import { getFullName } from 'utils/common';
import OpenButton from './buttons/OpenButton';
import CloseButton from './buttons/CloseButton';

import classes from './ContactList.module.scss';

const ContactList = ({ persons }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation(['activity']);

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  // eslint-disable-next-line react/display-name
  const listContactName = (firstName, lastName, role) => () => {
    const fullName = getFullName(firstName, lastName);
    return <ListContactName fullName={fullName} role={role} />;
  };

  const contact = (person, index, isOpen) => {
    const listContact = [
      listContactName(person.firstName, person.lastName, person.role),
      {
        title: t('activity:contacts.EMAIL'),
        value: person.email ? person.email : 'NA'
      },
      {
        title: t('activity:contacts.WORK_PHONE'),
        value: person.workPhone ? person.workPhone : 'NA'
      },
      {
        title: t('activity:contacts.MOBILE'),
        value: person.phone ? person.phone : 'NA'
      },
      {
        title: t('activity:contacts.LINKEDIN'),
        value: person.linkedin ? person.linkedin : 'NA'
      }
    ];

    const line = () => (
      <div
        key={`${person.firstName}${person.lastName}-${index}`}
        className={classes.info}
      >
        <Cells listData={listContact} />
      </div>
    );

    if (isOpen) {
      return line();
    } else {
      if (index < 3) {
        return line();
      } else {
        return '';
      }
    }
  };

  return (
    <>
      <div className={classes.header}>
        <PageSubTitle title={t('activity:contacts.CONTACT_PERSON')} />
        {persons.length > 3 && !isOpen ? (
          <OpenButton onClick={handleOpen} />
        ) : null}
      </div>
      {persons.map((person, index) => contact(person, index, isOpen))}
      <div className={classes.close}>
        {isOpen ? <CloseButton onClick={handleClose} /> : null}
      </div>
    </>
  );
};

ContactList.propTypes = {
  persons: PropTypes.arrayOf(object)
};

export default ContactList;
